import {createRouter, createWebHistory} from 'vue-router'
import DeviceList from '../views/DeviceList.vue'
import Dashboard from '../views/Dashboard.vue'
import keycloak from '../keycloak'

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: {requiresAuth: true},
  },
  {
    path: '/devices',
    name: 'devices',
    component: DeviceList,
    meta: {requiresAuth: true},
  },
  {
    path: '/device/:id',
    name: 'device-edit',
    component: () => import('../views/DeviceEdit.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/device/new',
    name: 'device-new',
    component: () => import('../views/DeviceEdit.vue'),
    meta: { requiresAuth: true },
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !keycloak.authenticated) {
    keycloak.login()
  } else {
    next()
  }
})

export default router
